export default __webpack_public_path__ + "static/media/SEC1580.34I-39290_-25437_0.b865efb4.jpg";